import { configs, envs } from "./configs";

/**
 * Build provider profile identifier from organization slug.
 * In local/preproduction we prefix with `dev-` to avoid collisions with production.
 */
export function getSocialProfileIdentifierFromOrgSlug(
	organizationSlug: string,
): string {
	const isDev = [envs.LOCALHOST, envs.PREPRODUCTION].includes(configs.env);
	const prefix = isDev ? "dev-" : "";
	return `${prefix}${organizationSlug}`;
}
